/**
 * Lite JWT 取得邏輯（SSOT）
 * 優先從 URL 讀取 jwt_token / token 並寫入 storage，否則從 storage 讀取
 */

import { getLiteJwtToken, setLiteJwtToken } from '../api/liteAuthToken.js';

/**
 * 取得 Lite JWT：先檢查 URL（jwt_token / token），有則寫入 storage 並回傳；否則從 storage 取得
 */
export function getLiteJwtTokenFromUrlOrStorage(): string | null {
  if (typeof window === 'undefined') return null;

  const urlParams = new URLSearchParams(window.location.search);
  const fromUrl = urlParams.get('jwt_token') || urlParams.get('token');
  if (fromUrl) {
    setLiteJwtToken(fromUrl);
    return fromUrl;
  }

  return getLiteJwtToken();
}
